export default "__VITE_ASSET__BfxJrBkr__"